import { h } from 'preact';
import { useEffect, useMemo, useState } from 'preact/hooks';
import { useInitiativesStore } from '../../store/initiativesStore.js';

function Filters() {
  const filters = useInitiativesStore(s => s.filters);
  const setFilters = useInitiativesStore(s => s.setFilters);
  const sortBy = useInitiativesStore(s => s.sortBy);
  const sortOrder = useInitiativesStore(s => s.sortOrder);
  const setSort = useInitiativesStore(s => s.setSort);
  return (
    <div class="filters-bar">
      <input
        class="filter-search"
        placeholder="Search initiatives..."
        value={filters.search}
        onInput={(e) => setFilters({ search: e.currentTarget.value })}
      />
      <select class="filter-select" value={filters.status} onChange={(e) => setFilters({ status: e.currentTarget.value })}>
        <option value="">All Status</option>
        <option value="not-started">Not Started</option>
        <option value="in-progress">In Progress</option>
        <option value="at-risk">At Risk</option>
        <option value="completed">Completed</option>
      </select>
      <select class="filter-select" value={filters.priority} onChange={(e) => setFilters({ priority: e.currentTarget.value })}>
        <option value="">All Priority</option>
        <option value="low">Low</option>
        <option value="medium">Medium</option>
        <option value="high">High</option>
        <option value="critical">Critical</option>
      </select>
      <select class="filter-select" value={sortBy} onChange={(e) => setSort(e.currentTarget.value, sortOrder)}>
        <option value="createdAt">Sort by Date</option>
        <option value="title">Sort by Title</option>
        <option value="progress">Sort by Progress</option>
        <option value="priority">Sort by Priority</option>
      </select>
    </div>
  );
}

function Row({ i, onEdit, onDelete }) {
  const statusColors = {
    'not-started': '#6c757d',
    'in-progress': '#005EB8',
    'at-risk': '#ff6b6b',
    'completed': '#28a745',
    'cancelled': '#dc3545'
  };
  const priorityBadges = { low: '🔵', medium: '🟡', high: '🟠', critical: '🔴' };
  return (
    <tr>
      <td style={{whiteSpace:'nowrap'}}>{new Date(i.createdAt || Date.now()).toLocaleDateString()}</td>
      <td>
        <div style="display:flex;gap:6px;align-items:center">
          <strong>{i.title}</strong>
          <span title={i.priority}>{priorityBadges[i.priority] || ''}</span>
        </div>
        <div class="text-secondary" style="font-size:12px">{i.objective}</div>
      </td>
      <td><span class="status-badge" style={`background-color:${statusColors[i.status]}`}>{(i.status||'').replace('-', ' ')}</span></td>
      <td style={{textAlign:'right'}}>
        <button class="btn-icon" onClick={()=>onEdit(i.id)} title="Edit">✏️</button>
        <button class="btn-icon" onClick={()=>onDelete(i.id)} title="Delete">🗑️</button>
      </td>
    </tr>
  );
}

export function InitiativesTable({ onEdit, onDelete }) {
  const getFilteredSorted = useInitiativesStore(s => s.getFilteredSorted);
  const list = getFilteredSorted();
  return (
    <div>
      <Filters />
      {list.length === 0 ? (
        <div class="empty-state">
          <p>No initiatives found</p>
        </div>
      ) : (
        <table class="uk-table" style="width:100%">
          <thead>
            <tr><th>Date</th><th>Initiative</th><th>Status</th><th></th></tr>
          </thead>
          <tbody>
            {list.map(i => <Row i={i} onEdit={onEdit} onDelete={onDelete} />)}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default InitiativesTable;

